import { render, staticRenderFns } from "./carousel-controls-visibility.vue?vue&type=template&id=342ebd5e&"
import script from "./carousel-controls-visibility.vue?vue&type=script&lang=js&"
export * from "./carousel-controls-visibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports